import { canDownload, canRead } from '../access/rbacAccess'

export const REPORTS = {
  LIST: 'mide.reports',
  TIMESTAMP_TAB: 'mide.reports.user_summary.timestamp_tab'
}

export const canViewReports = () => canRead(REPORTS.LIST)

export const canDownloadReports = () => canDownload(REPORTS.LIST)

export const canViewReportTimestampTab = () => canRead(REPORTS.TIMESTAMP_TAB)

export const canDownloadReportTimestampTab = () => canDownload(REPORTS.TIMESTAMP_TAB)
